import axios from 'axios'

export default class {
  _folderUrlAll
  _folderUrlCreate
  _folderUrlRead
  _folderUrlUpdate
  _folderUrlDelete
  _additionalConfig

  constructor() {
    this._folderUrlAll = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_GET_ALL_FOLDERS}`
    this._folderUrlCreate = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_CREATE_FOLDER}`
    this._folderUrlRead = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_GET_FOLDER}`
    this._folderUrlUpdate = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_UPDATE_FOLDER}`
    this._folderUrlDelete = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_DELETE_FOLDER}`
    this._additionalConfig = {
      headers: {
        'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`
      }
    }
  }

  getFolders() {
    return axios.get(this._folderUrlAll, this._additionalConfig)
  }

  getFolder(id) {
    return axios.get(`${this._folderUrlRead}/${id}`, this._additionalConfig)
  }

  createFolder(folder) {
    return axios.post(this._folderUrlCreate, folder, this._additionalConfig)
  }

  updateFolder(id, folder) {
    return axios.put(
      `${this._folderUrlUpdate}/${id}`,
      folder,
      this._additionalConfig
    )
  }

  deleteFolder(id) {
    return axios.delete(
      `${this._folderUrlDelete}/${id}`,
      this._additionalConfig
    )
  }
}
